
import reactIntlUniversal from "react-intl-universal";

export default {

    init(currentLocale) {
        reactIntlUniversal.init({
            currentLocale,
            locales: {
                "de": this.messages,
            },
        });
    },

    messages: {
        common: {
            edit: "Bearbeiten",
            duplicate: "Duplizieren",
            delete: "Löschen",
            create: "Anlegen",
            save: "Speichern",
            cancel: "Abbrechen",
            quit: "Verlassen",
            next: "Weiter",
            back: "Zurück",
            refresh: "Aktualisieren",
            upload: "Hochladen",
            download: "Herunterladen",
            close: "Schließen",
            datePlaceholder: "tt.mm.jjjj",
            ok: "OK",
            enabled: "Aktiviert",
            apply: "Übernehmen",
            reset: "Zurücksetzen",
            browse: "Durchsuchen",
            chooseFile: "Datei auswählen",
            notFound: "404 Seite nicht gefunden",
            loadingText: "Datensätze werden geladen",
        },
        notification: {
            calculations: {
                complete: "Berechnungen abgeschloßen ''{entryName}''",
                failure: "Berechnung abgebrochen ''{entryName}''",
            },
        },
        header: {
            logout: "Abmelden",
        },
        login: {
            username: "Benutzername",
            password: "Passwort",
            login: "Anmelden",
            error: {
                login: "Der eingegebene Benutzername oder das Passwort ist falsch",
            },
            footer: {
                imprint: "Impressum",
                privacy: "Datenschutzerklärung"
            },
        },
        navigation: {
            navigation: "Navigation",
            administration: "Administration",
            entries: "Datensätze",
            antennas: "Antennen",
            settings: "Einstellungen",
            manual: "Handbuch",
            news: "Neuigkeiten",
            agreement: "Nutzungsbedingungen",
            runners: "Runner",
            users: "Benutzer",
            documents: "Dokumente",
            worstcaseData: "Worstcase Daten",
        },
        update: {
            title: "Eine neue Version ist verfügbar",
            body: "Damit Sie die neueste Version nutzen können, muss die Seite neu geladen werden",
            confirm: "Jetzt Seite neu laden",
        },
        antennas: {
            manufacturer: "Hersteller",
            name: "Antennenname",
            apertureHeight: "Antennenlänge",
            originType: "Ursprungstyp",
            mapping: "Mapping",
        },
        entries: {
            createMulti: "Antennenanlage",
            loadingText: "Datensätze werden geladen",
            siteNum: "Standortnr.",
            name: "Name",
            owner: "Besitzer",
            calculatedAt: "Berechnet am",
            progress: "Fortschritt",
            queueOrder: "Warteschlange ({order})",
            fieldType: "Feld Typ",
            spatialArea: "Raumgebiet",
            environmentFactor: "Umfeldfaktor",
        },
        document: {
            loadingText: "Dokument wird geladen",
        },
        entry: {
            siteNum: "Standortnr.",
            name: "Datensatz Name",
            comments: "Kommentar",
            deleteConfirmation: "Soll der Datensatz ''{name}'' wirklich gelöscht werden?",
            wait: "warte...",
            myEntries: "Meine Daten",
            allEntries: "Alle Daten",
            loadingImage: "Bild wird geladen",
            deactivateAll: "Alle deaktivieren",
            activateAll: "Alle aktivieren",
            setMinDowntilts: "Min. Downtilts setzen",
            setMaxDowntilts: "Max. Downtilts setzen",
            expandAll: "Alle aufklappen",
            collapseAll: "Alle zuklappen",
            farField: "FF",
            nearField: "NF",
            merge: "Hinzufügen",
            downloadOnlyHorizontalAreasErrorMessage: "Areale mit Neigung können noch nicht beantragt werden.",
            downloadAustriaExcel: "Datenblatt",
            area: "Area",
            calculate: "Berechnen",
            progress: "Fortschritt",
            calcelCalculation: "Berechnung abbrechen",
            calculateOptions: {
                overviewStandard: "Übersicht Standard",
                overviewFlexible: "Übersicht Flexibel",
                overviewFlexibleWc: "Übersicht Flexibel WC",
                overviewStandardWc: "Übersicht Standard WC",
                wattwaechter: "Wattwächter",
                worstcase: "Worstcase",
                ixus: "IXUS Arbeitsschutz",
            },
            downloadOptions: {
                wwjson: "WWJson",
                wwmobil: "WWMobil",
                austriaExcel: "Datenblatt",
                ixusReport: "IXUS Report",
            },
            overview: "Übersicht",
            wattwaechter: "Wattwächter",
            worstcase: "Worstcase",
            tabs: {
                radios: "Funksysteme",
                plan: "Plan",
                ixus: "IXUS Arbeitsschutz",
            },
            radio: {
                systemName: "System Name",
                operatorName: "Betreiber",
                antennaManufacturer: "Hersteller",
                antennaName: "Antennen Model",
                antennaFrequency: "Frequenz (MHz)",
                antennaPort: "Port",
                antennaElecDowntilt: "El. Downtilt (°)",
                frequency: "Op. Frequenz (MHz)",
                comments: "Kommentar",
                positionX: "x-Position (m)",
                positionY: "y-Position (m)",
                height: "Höhe (z)",
                direction: "Ausrichtung (°)",
                mechDowntilt: "Mech. Downtilt (°)",
                numChannels: "Anzahl Kanäle",
                txPower: "TX Leistung/Kanal (W)",
                attenuation: "Dämpfung (dB)",
                addAntenna: "Antenne hinzufügen",
                addRadio: "Funksystem hinzufügen",
                radioCountSingle: "1 Funksystem",
                radioCount: "{count} Funksysteme",
                radioCountEnabled: "{enabled}/{count} Funksysteme aktiv",
                noRadios: "Keine Funksysteme",
                info: {
                    newModel: "Es liegen neue Fielddatensätze vor"
                }
            },
            wattwaechterSetting: {
                areas: "Areale",
                fieldType: "Feld Typ",
                originX: "Ursprung X (m)",
                originY: "Ursprung Y (m)",
                height: "Höhe (m)",
                dimensionU: "Dimension U (m)",
                dimensionV: "Dimension V (m)",
                rotationAzimuth: "Rotation Azimuth (°)",
                resolution: "Auflösung",
                sliceNum: "Schnitt Num.",
                sliceDist: "Schnitt Dist. (m)",
                preferFarField: "Fernfeld",
                fastCalc: "Schnell",
                sliceHeight: "Schnitt (z)",
                environmentFactor: "Umfeldfaktor",
                error: {
                    sliceNum: {
                        maxSlices: "Für die Auflösung {resolution} sind maximal {max} Schnitte erlaubt.",
                    }
                }
            },
            worstcaseSetting: {
                areas: "Areale",
                resolution: "Auflösung",
                environmentFactor: "Umfeldfaktor"
            },
            overviewSetting: {
                fieldType: "Feld Typ",
                fieldLimit: "Grenzwert",
                useWorstcase: "Worstcase Daten",
            },
            plan: {
                plans: {
                    title: "Pläne",
                    name: "Name",
                    defaultName: "Ebene {number}",
                    opacity: "Deckkraft",
                    add: "Plan hinzufügen",
                    rotationAngle: "Rotation",
                    page: "Seite",
                    grayscale: "Graustufen",
                    scale: "Maßstab (m)",
                    setScale: "Maßstab setzen",
                    angle: "Winkel (°)",
                    setAngle: "Winkel setzen",
                    setOrigin: "Referenzpunkt setzen",
                },
                areas: {
                    title: "Areal",
                    name: "Name",
                    height: "Höhe (m)",
                    heightLow: "H. tief (m)",
                    inclination: "Neig. (°)",
                    attenuation: "Dämpfung",
                    global: "Global",
                    attenuationClass: "Klasse",
                    thickness: "Dicke",
                    attenuation1: "Dämpfung 1 (dB)",
                    attenuationFrequency1: "Frequenz 1 (MHz)",
                    attenuation2: "Dämpfung 2 (dB)",
                    attenuationFrequency2: "Frequenz 2 (MHz)",
                    add: "Areal hinzufügen",
                    attenuationClass1: "1-Beton ITU",
                    attenuationClass2: "2-Beton",
                    attenuationClass3: "3-Metall",
                    attenuationClass4: "4-Ziegel",
                    attenuationClassCustom: "Eigene",
                    p1x: "P1x",
                    p1y: "P1y",
                    p1z: "P1z",
                    p2x: "P2x",
                    p2y: "P2y",
                    p2z: "P2z",
                    p3x: "P3x",
                    p3y: "P3y",
                    p3z: "P3z",
                },
                antennas: {
                    title: "Antennen",
                    selectedX: "Ausgewählt X",
                    selectedY: "Ausgewählt Y",
                },
                measure: {
                    title: "Messen",
                },
                wattwaechter: {
                    title: "Wattwächter",
                    fieldType: "Feld Typ",
                    slice: "Schnitt",
                    fieldMax: "Feld max",
                    colorScale: "Farbe",
                    marker: "Marker",
                    grid: "Gitter",
                    logScale: "Logarithmisch",
                    colorScaleAuto: "Auto. Farbscala",
                    colorScaleLowerLimit: "Unteres Limit",
                    colorScaleUpperLimit: "Oberes Limit",
                    analysePoint: "Punkt Analyse starten",
                    selectionActiate: "Bereichauswahl",
                    pointSelectionActiate: "Punktauswahl",
                    visible: "Sichtbar",
                    pointAnalysisVisible: "PA. Sichtbar",
                    boundaryClipped: "Angepasst",
                    name: "Name",
                    height: "Höhe (m)",
                    heightLow: "Höhe tief (m)",
                    gwa: "GWA",
                    resultDialog: {
                        topView: "Wattwächter - Draufsicht",
                        sideView: "Wattwächter - Seitenansicht",
                        angleView: "Wattwächter - Schrägansicht ({inclination}°)",
                    }
                },
                worstcase: {
                    title: "Worstcase",
                    radio: "Funksystem",
                    field: "GWA",
                    wcfDownload: "WCF WWMobil herunterladen",
                    positionX: "x-Position (m)",
                    positionY: "y-Position (m)",
                    systemName: "System Name",
                    antennaFrequency: "Freq. (MHz)",
                    antennaElecDowntilt: "El. Downtilt (°)",
                    antennaPort: "Port",
                    createNew: "Neuen Worstcase Datensatz anlegen",
                    analysePoint: "Punkt Analyse starten",
                    selectionActiate: "Bereichauswahl",
                    pointSelectionActiate: "Punktauswahl",
                    visible: "Sichtbar",
                    boundaryClipped: "Angepasst",
                    name: "Name",
                    resultDialog: {
                        topView: "Worstcase - Draufsicht",
                        sideView: "Worstcase - Seitenansicht",
                        angleView: "Worstcase - Schrägansicht ({inclination}°)",
                    }
                },
                overview: {
                    title: "Übersicht",
                    loadingImage: "Bild wird geladen",
                },
                overview3d: {
                    title: "Übersicht 3D",
                    outdoorResultVisible: "Ergebnis KB-unkritisch",
                    indoorResultVisible: "Ergebnis KB-Verletzend",
                    planVisible: "Pläne",
                    attenuationGlobal: "Globale Dämpfung 10dB",
                    resetView: "Ansicht zurücksetzen",
                    buildingElevation: "m ü. NHN",
                    buildingsVisible: "Gebäude sichtbar",
                    buildingTranslationX: "Korr. X [m]",
                    buildingTranslationY: "Y [m]",
                    buildingTranslationZ: "Z [m]",
                    importAreas: "Areale importieren",
                    antennasListTitle: "Abstand der Antennen von den Ebenen",
                    latitude: "Breitengrad (°)",
                    longitude: "Längengrad (°)",
                    radius: "Radius (m)",
                },
                download: {
                    title: "Herunterladen",
                    downloadCanvas: "Gesamtbild Herunterladen",
                    downloadSelection: "Bereich Herunterladen",
                },
            },
            ixus: {
                main: {
                    title: "Ansichten",
                    name: "Name",
                    sideView: "Seite",
                    angle: "Winkel (°)",
                    heightTop: "Höhe oben (m)",
                    heightBottom: "Höhe unten (m)",
                    transform: "Verschiebung anzeigen",
                    transformTitle: "Verschiebung und Skalierung des Ergebnisbilds",
                    offsetX: "Verschiebung X (m)",
                    offsetY: "Verschiebung Y (m)",
                    scaleX: "Skalierung X (Faktor)",
                    scaleY: "Skalierung Y (Faktor)",
                },
                measurement: {
                    title: "Messen",
                    level: "Ebene",
                    defaultLevel: "Ebene {number}",
                    note: "Betreiber / Hinweis",
                    placeHint: "Maß auf dem Plan zeichnen, um den Abstand zu setzen.",
                    direction: {
                        FRONT: "Vorne",
                        TOP_BOTTOM: "Oben/Unten",
                        SIDES: "Rechts/Links",
                        BACK: "Hinten",
                    },
                },
                safetyDistances: {
                    title: "Sicherheitsabstände",
                    front: "vorne:",
                    topBottom: "oben, unten:",
                    sides: "rechts, links:",
                    back: "hinten:",
                },
                textFields: {
                    placeHint: "Auf den Plan klicken, um das Element zu platzieren.",
                    arrowPlaceHint: "Start- und Endpunkt auf dem Plan anklicken.",
                    safetyDistances: "Sicherheitsabstände",
                    safetyDistancesLevel: "Sicherheitsabstände: Ebene {level}",
                    freeText: "Freier Text",
                    freeTextTitle: "Freien Text eingeben",
                    freeTextPlaceholder: "Text für den Plan …",
                    cloud: "Gefahrbereich (Wolke)",
                    arrow: "Pfeil",
                    redLine: "Line",
                    directionalRadio: "Richtfunk-Symbol",
                    directionalRadioCaption: "Richtfunk (Parabolspiegel)\nkein Sicherheitsabstand",
                    climbingSquare: "Durchstieg (80 cm)",
                    // Full backend wording (IxusReportService.java TEXT_* constants) - used to match
                    // the palette button clicked against a short label below, not for display itself.
                    fullText: {
                        roofSurfaceClear: "Schild vom Verkehrsweg gut sichtbar an jeder Telekom-Antenne anbringen",
                        roofSurfaceNotClear: "Schild vom Verkehrsweg gut sichtbar an jeder Telekom-Antenne und innen am Dachzugang anbringen",
                        aerialWorkPlatform: "Hubsteigerstandort: Schilder von vorne an jeder Telekom-Antenne anbringen",
                        aerialWorkPlatformRoofAccessNotClear: "Hubsteigerstandort: Schilder von vorne an jeder Telekom-Antenne und innen am Dachzugang anbringen",
                        climbingLadderClear: "Schild vom Verkehrsweg gut sichtbar unterhalb des Beginns des Gefahrbereichs anbringen",
                        climbingLadderRoofAccessNotClear: "Schild vom Verkehrsweg gut sichtbar innen am Dachzugang anbringen",
                        climbingPathNotClear: "Sicherheitsabstand ragt in Steigweg. Vor Durchstieg Schutzmaßnahmen ergreifen!",
                        thirdPartySite: "Standort Dritter: Kennzeichnung ist zusätzlich am Steigschutz anzubringen!",
                        operatorsConsidered: "Gefahrbereichsbetrachtung gilt nur für Telekom Deutschland Antennen unter Berücksichtigung der benachbarten Antennen! Abweichende Sicherheitsabstände der anderen Funkbetreiber beachten!",
                        operatorsNotConsidered: "Gefahrbereichsbetrachtung gilt nur für Telekom Deutschland Antennen! Sicherheitsabstände der anderen Funkbetreiber beachten!",
                        operatorsOwnMarking: "Falls der Betreiber zusätzlich eine eigene Kennzeichnung angebracht hat, sind beide Sicherheitsabstände korrekt und zu beachten.",
                        directionalRadio: "Richtfunk (Parabolspiegel) — kein Sicherheitsabstand",
                        safetyDistanceBelow05m: "Sonstige, Sicherheitsabstand < 0,5 m — Keine Kennzeichnung erforderlich!",
                        operatorMarking: "Kennzeichnung {operators} erfolgt durch den Antennenbetreiber. Abstände sind entsprechend der Betreiberkennzeichnung einzuhalten.",
                    },
                    shortLabel: {
                        roofSurfaceClear: "Schild an jeder Telekom-Antenne anbringen",
                        roofSurfaceNotClear: "Schild an Antenne + Dachzugang anbringen",
                        aerialWorkPlatform: "Hubsteiger: Schild vorne an Antenne anbringen",
                        aerialWorkPlatformRoofAccessNotClear: "Hubsteiger: Schild an Antenne + Dachzugang",
                        climbingLadderClear: "Schild unterhalb Gefahrbereich anbringen",
                        climbingLadderRoofAccessNotClear: "Schild innen am Dachzugang anbringen",
                        climbingPathNotClear: "Sicherheitsabstand ragt in Steigweg!",
                        thirdPartySite: "Standort Dritter: Kennz. am Steigschutz",
                        operatorsConsidered: "Gefahrbereich gilt nur für Telekom (mit Nachbarantennen)",
                        operatorsNotConsidered: "Gefahrbereich gilt nur für Telekom Deutschland",
                        operatorsOwnMarking: "Beide Sicherheitsabstände ggf. korrekt/zu beachten",
                        safetyDistanceBelow05m: "Sonstige < 0,5 m: keine Kennzeichnung nötig",
                        operatorMarking: "Kennzeichnung {operators} durch Betreiber",
                    },
                },
                siteInfo: {
                    title: "Info",
                    selectImage: "Deckblatt Bild",
                    siteTypeInput: {
                        title: "Standortart",
                    },
                    antennaAccessInput: {
                        title: "Zugang zu Antennen",
                    },
                    climbingPathClearInput: {
                        title: "Steigweg frei",
                    },
                    roofAccessClearInput: {
                        title: "Dachzugang frei",
                        titleDangerZone: "Antennen frei von Gefahrbereich (2,30m)",
                    },
                    otherOperatorsInput: {
                        title: "Andere Mobilfunkbetreiber am Standort",
                    },
                    otherOperatorsConsideredInput: {
                        title: "Mitbetrachtet",
                    },
                    otherAntennasInput: {
                        title: "Weitere Antennen am Standort",
                    },
                }
            },
            ixusReport: {
                reportButton: "IXUS Report",
                downloadButton: "Runterladen"
            },
            report: {
                reportButton: "Report",
                dialogTitle: "Report erstellen",
                entrySelect: "Datensatz",
                areasSelect: "Areale",
                wcLabel: "WC",
                wwLabel: "WW",
                downloadButton: "Runterladen",
                sliceSelect: "Schnitt",
                fieldMax: "Feld max",
                evaluationInput: {
                    title: "Beurteilung",
                    POSITIVE: "Genehmigungsfähig",
                    NEGATIVE: "Nicht genehmigungsfähig",
                    CHANGE_REQUIRED: "Genehmigungsfähig mit Änderungen",
                },
                planDefectInput: {
                    title: "Hinweise Bauplan",
                    NO_REF_POINT_PLAN: "Referenzpunkt Lageplan fehlt",
                    NO_REF_POINT_VIEW: "Referenzpunkt Draufsicht fehlt",
                    WRONG_SCALE_PLAN: "Maßstab Lageplan falsch",
                    WRONG_SCALE_VIEW: "Maßstab Draufsicht falsch",
                    WRONG_DIRECTION_PLAN: "Ausrichtung Lageplan falsch",
                    WRONG_DIRECTION_VIEW: "Ausrichtung Draufsicht falsch",
                    WRONG_CONTROL_AREA_BOUNDARIES: "Fehlerhafte KB-Grenzen im Lageplan",
                    WRONG_CONTROL_AREA_BOUNDARIES_SIDEVIEW: "Fehlerhafte KB-Grenzen in Seitenansicht",
                    MISSING_NOTATION_REINFORCEMENT_CONTROL_AREA_SIDEVIEW: "Fehlender Vermerk der Sicherung KB in Seitenansicht"
                },
                customPlanDefectInputTitle: "Weitere Hinweise Bauplan",
                evidenceInput: "Beweisführung",
                showRadioTable: "Funkkonfiguration im Report anzeigen"
            }
        },
        agreement: {
            accept: "Ich erkläre mich mit der Geltung der Nutzungsbedingungen für MxWell einverstanden",
        },
        settings: {
            password: {
                title: "Password ändern",
                old: "Altes Passwort",
                new: "Neues Passwort",
                repeat: "Passwort wiederholen",
                error: {
                    presence: "Dieses Feld darf nicht leer sein",
                    repeat: "Passwort Wiederholung stimmt nicht überein",
                    length: "Muss mindestens aus 8 Zeichen bestehen",
                    previous: "Vorheriges Password nicht korrekt",
                    strength: "Muss mindestens einen Groß- und Kleinbuchstaben, eine Zahl und ein Sonderzeichen ($&@?<>~!%#) enthalten",
                }
            },
        },
        antennaSystem: {
            system: "Funksysteme",
            vendor: "Systemhersteller",
            selection: "Bereits hinzugefügt",
            add: "Hinzufügen",
        },
        users: {
            username: "Benutzername",
            administrator: "Admin",
            email: "E-Mail",
            createdAt: "Angelegt am",
            company: "Betreiber",
            active: "Aktiv",
            create: "Anlegen",
            downloadUserStatsCsv: "Statistiken herunterladen",
            downloadUserListCsv: "Benutzerliste herunterladen",
        },
        user: {
            activate: "Aktivieren",
            deactivate: "Deaktivieren",
            resetPassword: "Password zurücksetzen",
            resetPasswordConfirmation: "Soll das Passwort für den Benutzer ''{username}'' zurückgesetzt werden?",
            activateConfirmation: "Soll der Benutzer ''{username}'' aktiviert werden?",
            deactivateConfirmation: "Soll der Benutzer ''{username}'' deaktiviert werden?",
            error: {
                companyName: {
                    presence: "Dieses Feld darf nicht leer sein",
                },
                username: {
                    presence: "Dieses Feld darf nicht leer sein",
                    used: "Dieser Benutzername ist bereits vergeben",
                    format: "Nur Kleinbuchstaben und '-' erlaubt. Keine Sonderzeichen.",
                },
                email: {
                    presence: "Dieses Feld darf nicht leer sein",
                    format: "Bitte gültige E-Mail angeben",
                }
            }
        },
        runners: {
            name: "Name",
            active: "Aktiv",
            stale: "Reglos",
            cancel: "Abbrechen",
            restart: "Neustarten",
            restartAll: "Alle neustarten",
            calculationType: "Berechnungstyp",
            calculationProgress: "Fortschritt",
            username: "Benutzer",
            companyName: "Betreiber",
            subjectName: "Subjekt",
        },
        worstcaseData: {
            syncronize: "Antennen synchronisieren",
            resultAvailable: "Ergebnis",
            calculate: "Berechnen",
            calculateWorstcaseData: "Worstcase Daten berechnen",
            createVirtualAntenna: "Virtuelle Antenne anlegen",
        },
        exception: {
            title: "Ein Fehler ist aufgetreten",
            unknown: "Ein unbekannter Fehler ist aufgetreten",
            unauthorized: "Ihre Anmeldung ist nicht mehr gültig",
            validateEntry: "Speichern nicht möglich. Bitte überprüfen Sie die folgenden Bereiche auf fehlerhafte Parameter: {errorLocations}",
            noSuitableFieldDataFor: "Für die Antenne ''{antennaName}'' und der Betreiber-Frequenz ''{frequency}'' gibt es keine passende Field-Daten.",
            missingOperator: "Bitte für alle Funksysteme einen Betreiber auswählen, bevor die Punktanalyse gestartet werden kann.",
            import: {
                format: "Import kann nicht durchgeführt werden. Unbekannte Dateiendung ''{extension}''",
                wwmobil: {
                    filename: "Maximal erlaubte länge des Dateinamens sind {maxLength} Zeichen",
                    json: "Syntax Fehler in Zeile {lineNr}, Spalte {columnNr}",
                    nullValue: "Der Wert 'null' ist nicht erlaubt. Zeile {lineNr} in Feld ''{key}''",
                },
                wwjson: {
                    invalidRegionType: "Regionstyp ''{regionType}'' wird nicht unterstützt",
                    invalidAttenuation: "Fehlende oder ungültige Dämpfung",
                    invalidPlane: "Fehlerhafte oder ungültige Ebenendefinition",
                },
            }
        },
        enum: {
            operator: {
                TELEFONICA: "Telefonica",
                TELEKOM: "Telekom",
                VODAFONE: "Vodafone",
                _1UND1: "1&1",
                TOWERS_AT: "Towers AT",
            },
            colorScale: {
                RGB: "RGB",
                HOT: "Hot",
                GRAY: "Gray",
            },
            marker: {
                NONE: "Keine",
                SMALL: "Klein",
                LARGE: "Groß",
            },
            grid: {
                NONE: "Keine",
                COARSE: "Grob",
                FINE: "Fein",
            },
            view: {
                SOUTH_NORD: "Süd-Nord Ansicht",
                EAST_WEST: "West-Ost Ansicht",
            },
            fieldType: {
                E_FIELD: "E-Field",
                H_FIELD: "H-Field",
                PROTECTION_AREA_BLMSCHV: "Protection-area-BlmSchV",
                PROTECTION_AREA_EXP_1: "Protection-area-Exp.1",
                EXHAUSTION_FACTOR_BLMSCHV: "Exhaustion-factor-BlmSchV",
                EXHAUSTION_FACTOR_EXP_1: "Exhaustion-factor-Exp.1",
            },
            antennaSystem: {
                VENDOR_1: "1",
                VENDOR_2: "2",
            },
            calculationType: {
                OVERVIEW: "Übersicht",
                WATTWAECHTER: "Wattwächter",
                WORSTCASE: "Worstcase",
                WORSTCASE_DATA: "Worstcase Daten",
            },
            ixusSiteType: {
                ROOFTOP: "Dach",
                ROOFTOP_AERIAL_WORK_PLATFORM: "Dach, Zugang über Hubsteiger",
                PYLON_NOT_DFMG: "Mast nicht DFMG",
                PYLON_DFMG_LE_60M: "Mast DFMG ≤60m",
                PYLON_DFMG_LE_60M_AERIAL_WORK_PLATFORM: "Mast DFMG ≤60m, Zugang über Hubsteiger",
                PYLON_DFMG_GT_60M: "Mast DFMG >60m",
                MAJOR_SITE: "Großstandort",
            },
            ixusAntennaAccess: {
                ROOF_SURFACE: "Dachfläche",
                GRP_CYLINDER: "GFK Zylinder",
                CLIMBING_LADDER: "Steigleiter",
                AERIAL_WORK_PLATFORM: "Hubsteiger",
            },
            ixusOtherOperator: {
                TELEFONICA: "Telefónica",
                VODAFONE: "Vodafone",
                _1UND1: "1&1",
            },
            ixusOtherAntenna: {
                DIRECTIONAL_RADIO: "Richtfunk",
                RECEIVING_ANTENNAS: "Empfangsantennen",
                ANTENNAS_OUT_OF_SERVICE: "Antennen außer Betrieb",
                ANTENNAS_WITH_SAFETY_DISTANCE_BELOW_0_5M: "Antennen mit Sicherheitsabstand < 0,5m",
            },
        },
    }
};